"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const design_tokens_1 = __importDefault(require("./design-tokens"));
const legacyTokens = {
    '$colour-ikea-coworker-blue': '#151e44',
    '$colour-ikea-coworker-yellow': '#ffcd3f',
    '$thickness-thick-rem': '.125rem',
    '$thickness-thin-rem': '.0625rem',
    '$body-line-height': '1.7142',
    '$body-line-height-s': '1.5',
    '$form-input-label-offset': '1.4375rem',
    '$form-input-label-size-default': '1rem',
    '$form-input-label-size-small': '.75rem',
    '$grid-max-width': '112rem',
    '$layer-1': '100',
    '$layer-2': '200',
    '$layer-3': '300',
    '$layer-4': '400'
};
const mergedTokens = Object.assign(Object.assign({}, legacyTokens), design_tokens_1.default);
exports.default = mergedTokens;
__exportStar(require("./design-tokens"), exports);
